import React from "react";
import img1 from "../../../images/consulting/CRM-Consulting1-1024x683.png.webp";
import img2 from "../../../images/consulting/CRM-Consulting2-1024x683.png.webp";
import img3 from "../../../images/consulting/CRM-Consulting3-1024x683.png.webp";
import img4 from "../../../images/consulting/CRM-Consulting-1-1024x683.png.webp";

const Crmconsulting: React.FC = () => {
  const features = [
    {
      icon: "bi-gear",
      title: "Automate Manual Work",
      description: "Do more with less by automating repetitive tasks and removing operational drudgery across teams.",
      color: "#34d399",
      borderColor: "rgba(52, 211, 153, 0.3)"
    },
    {
      icon: "bi-database",
      title: "Unified Customer Data",
      description: "Create a centralized customer data hub that keeps sales, marketing, and service teams aligned.",
      color: "#60a5fa",
      borderColor: "rgba(96, 165, 250, 0.3)"
    },
    {
      icon: "bi-graph-up",
      title: "Actionable Insights",
      description: "Turn raw customer data into actionable insights with built-in analytics and real-time reporting.",
      color: "#22d3ee",
      borderColor: "rgba(34, 211, 238, 0.3)"
    }
  ];

  return (
    <>
      {/* Intro Section */}
      <section className="container mt-5">
        <h2 className="details-content-title mb-4">CRM Consulting with Brain Machine</h2>
        <p>
          We help you rethink your business processes and find room for optimization. Tap into Brain Machine CRM Consulting services to improve conversion rates and cross-sell to your customers or upsell them on your add-ons.<br /><br />
          Seize business opportunities all across the sales value chain. Tap into Brain Machine' CRM consulting services to improve conversion rates and cross-sell to your customers or upsell them on your add-ons.
        </p>
      </section>

      {/* Why Brain Machine Section */}
      <div className="why-section">
        <div className="container mb-25">
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="section-title" style={{color: 'white'}}>Why Brain Machine.AI</h2>
          </div>
          
          <div className="row g-4">
            {/* Benefit 1 */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="0">
              <div className="benefit-item clickable">
                <h3 className="benefit-title-alt">Accelerate CRM Implementation</h3>
                <div className="benefit-line">
                  <span className="benefit-number-badge" style={{background: '#a4c639'}}>01</span>
                </div>
              </div>
            </div>

            {/* Benefit 2 */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="benefit-item clickable">
                <h3 className="benefit-title-alt">Optimize CRM Investment</h3>
                <div className="benefit-line">
                  <span className="benefit-number-badge" style={{background: '#ffc107'}}>02</span>
                </div>
              </div>
            </div>

            {/* Benefit 3 */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="benefit-item clickable">
                <h3 className="benefit-title-alt">Ensure Data Security & Compliance</h3>
                <div className="benefit-line">
                  <span className="benefit-number-badge" style={{background: '#9c27b0'}}>03</span>
                </div>
              </div>
            </div>

            {/* Benefit 4 */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="benefit-item clickable">
                <h3 className="benefit-title-alt">Deliver High-Performance CRM Solutions</h3>
                <div className="benefit-line">
                  <span className="benefit-number-badge" style={{background: '#f44336'}}>04</span>
                </div>
              </div>
            </div>

            {/* Benefit 5 */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
              <div className="benefit-item clickable">
                <h3 className="benefit-title-alt">Flexible CRM Resource Scaling</h3>
                <div className="benefit-line">
                  <span className="benefit-number-badge" style={{background: '#2196f3'}}>05</span>
                </div>
              </div>
            </div>

            {/* Benefit 6 */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
              <div className="benefit-item clickable">
                <h3 className="benefit-title-alt">Proven CRM Delivery Framework</h3>
                <div className="benefit-line">
                  <span className="benefit-number-badge" style={{background: '#2196f3'}}>06</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CRM Implementation Solutions */}
      <section className="clarification-call pt-5">
        <div className="container mt-55">
          <h2 className="mb-25 pt-25 text-center w-75 mx-auto">Opt for your CRM implementation solution</h2>
          <p className="mt-3 mb-25 text-center w-75 mx-auto">
            Choose a CRM implementation tailored to your business goals, processes, and customer engagement strategy.
          </p>
          <div className="row align-items-center">
            {/* B2B CRM */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="content-wrapper">
                <h2 className="fw-bold mb-4 mt-55">B2B CRM</h2>
                <p className="callp">
                  Our custom CRM systems help you overcome channel complexity, operate across a range of markets, and get through to the right person – fast, easy, and within a single interface. Connect with vendor partners, resellers, or affiliate companies via an automated, easily trackable workflow.
                </p>
              </div>
            </div>

            {/* B2C CRM */}
            <div className="col-lg-6">
              <div className="content-wrapper">
                <h2 className="fw-bold mb-4 mt-55">B2C CRM</h2>
                <p className="callp">
                  Keep track of every opportunity and lead, increase the average value of sales through personalized experiences, and improve your marketing and customer retention strategies. Our feature-packed CRM software delivers ultimate visibility across your sales pipeline for more leads and maximized revenues.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Level Up Section with Bootstrap Icons */}
      <section className="py-5" style={{backgroundColor: '#020617'}}>
        <div className="container">
          {/* Section Header */}
          <div className="text-center mb-4 mx-auto" style={{maxWidth: '900px'}}>
            <h2 className="mb-25 pt-25 text-center w-75 mx-auto">
              Level up your customer strategy with our CRM consulting company
            </h2>
            <p className="fs-5" style={{color: '#94a3b8'}}>
              Build smarter, faster, and more connected customer experiences with the right CRM strategy and execution.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="row g-4 mt-5">
            {features.map((feature, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="position-relative">
                  {/* Vertical colored line */}
                  <div 
                    className="position-absolute start-0 top-0 bottom-0" 
                    style={{
                      width: '2px',
                      background: feature.borderColor,
                      marginLeft: '32px'
                    }}
                  ></div>
                  
                  {/* Card Content */}
                  <div className="ps-5 py-4">
                
                    {/* Title */}
                    <h5 
                      className="fw-bold mb-3" 
                      style={{
                        fontSize: '1.45rem',
                        color: feature.color
                      }}
                    >
                      {feature.title}
                    </h5>

                    {/* Description */}
                    <p style={{color: '#94a3b8', fontSize: '0.875rem'}}>
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Covering All Aspects Section */}
      <section className="clarification-call py-5 
      ">
        <div className="container ">
          <h2 className="mb-25 pt-25 text-center w-75 mx-auto">Covering all aspects of your CRM project</h2>
          <p className="mt-3 mb-25 text-center w-75 mx-auto">
            We assess your business processes, customer touchpoints, data sources, and integration requirements to define CRM priorities and deliver a solution that fully supports your customer engagement, sales, and service objectives.
          </p>

          {/* CRM Setup */}
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="content-wrapper">
                <h2 className="fw-bold mb-4 mt-55">CRM setup</h2>
                <p className="callp">
                  We make sure your system is off to a good start and is properly customized to drive every business process from top to bottom. Our experts will set up the organizational hierarchy, establish data visibility rules, and sort out email integration and lead generation processes to get you started on the right foot.
                </p>
                <ul className="custom-list">
                  <li>General system setup</li>
                  <li>CRM integration</li>
                  <li>Team access and permissions</li>
                  <li>Sales and marketing automation</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="image-wrapper">
                <img
                  src={img1}
                  alt="CRM Setup"
                  className="img-fluid"
                  style={{borderRadius: "8px"}}
                />
              </div>
            </div>
          </div>

          {/* CRM Customization */}
          <div className="row align-items-center pt-55">
            <div className="col-lg-6">
              <div className="image-wrapper">
                <img
                  src={img2}
                  alt="CRM Customization"
                  className="img-fluid"
                  style={{borderRadius: "8px"}}
                />
              </div>
            </div>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="content-wrapper">
                <h2 className="fw-bold mb-4 mt-45">CRM customization</h2>
                <p className="callp">
                  Our consulting CRM team configures your CRM platform to make it a perfect fit for your unique business tasks. Our developers build custom solutions, modules, and plug-ins on top of existing technologies like Odoo, Hubspot, Zoho, and other canned solutions, to minimize the time for critical tasks and to boost your productivity.
                </p>
                <ul className="custom-list">
                  <li>Custom pipelines and business flows</li>
                  <li>Custom CRM extensions</li>
                  <li>Custom reports and dashboard widgets</li>
                  <li>Third-party APIs and integrations</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Data Migration */}
          <div className="row align-items-center pt-55">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="content-wrapper">
                <h2 className="fw-bold mb-4 mt-55">Data migration</h2>
                <p className="callp">
                  We help you switch from legacy systems, migrate data from other business systems, or shift to the cloud. Our data engineers analyze your data requirements, prepare input for migration, and create backups so that you have a single source of truth based on accurate and complete insights.
                </p>
                <ul className="custom-list">
                  <li>Cloud migration</li>
                  <li>Data consolidation</li>
                  <li>Data preparation and cleaning</li>
                  <li>Migrating data from other CRMs</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="image-wrapper">
                <img
                  src={img3}
                  alt="Data Migration"
                  className="img-fluid"
                  style={{borderRadius: "8px"}}
                />
              </div>
            </div>
          </div>

          {/* CRM Maintenance */}
          <div className="row align-items-center pt-55">
            <div className="col-lg-6">
              <div className="image-wrapper">
                <img
                  src={img4}
                  alt="CRM Maintenance"
                  className="img-fluid"
                  style={{borderRadius: "8px"}}
                />
              </div>
            </div>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="content-wrapper">
                <h2 className="fw-bold mb-4 mt-45">CRM maintenance and update</h2>
                <p className="callp">
                  Our CRM software consulting unit keeps your solution at its peak performance, eliminates performance flaws, and updates the platform to match your evolving needs. We offer a full cycle of maintenance activities, including troubleshooting, data quality review, performance audits, and more.
                </p>
                <ul className="custom-list">
                  <li>L1-L3 support services</li>
                  <li>User training and documentation</li>
                  <li>CRM data maintenance</li>
                  <li>Feature update</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Crmconsulting;